<template>
  <div>
    <h3>活动已结束</h3>
  </div>
</template>

<script>
export default {
  name: 'blankPage',
  created() {
    // this.$router.push('/poster')
  }
}
</script>

<style scoped>

</style>
